"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wordSplit = exports.transitionToAuto = exports.svgStyle = exports.onKeySelect = exports.onKeyChoose = exports.mapProps = exports.iconStyle = exports.hexToRgb = exports.getRGBAFromHex = exports.getCDN = exports.filterChildProps = exports.deepCopy = exports.debounce = exports.cloneChildren = exports.camelize = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var hexToRgb = exports.hexToRgb = function hexToRgb(hex) {
  if (!hex) {
    return null;
  }
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var rgbObj = {
    r: result && parseInt(result[1], 16),
    g: result && parseInt(result[2], 16),
    b: result && parseInt(result[3], 16)
  };
  return result ? rgbObj : null;
};
var getRGBAFromHex = exports.getRGBAFromHex = function getRGBAFromHex(hex, alpha) {
  var rgbObj = hexToRgb(hex);
  return hex ? "rgba(".concat(rgbObj.r, ",").concat(rgbObj.g, ",").concat(rgbObj.b, ",").concat(alpha, ")") : null;
};
var cloneChildren = exports.cloneChildren = function cloneChildren(children, newProps) {
  if (Array.isArray(children)) {
    return children.map(function (ch) {
      return ch ? /*#__PURE__*/_react["default"].cloneElement(ch, newProps) : null;
    });
  }
  return children ? /*#__PURE__*/_react["default"].cloneElement(children, newProps) : null;
};
var deepCopy = exports.deepCopy = function deepCopy(obj) {
  var returnObj = null;
  try {
    returnObj = (0, _typeof2["default"])(obj) === "object" ? JSON.parse(JSON.stringify(obj)) : obj;
  } catch (error) {
    //do nothing
  }
  return returnObj;
};
var svgStyle = exports.svgStyle = /*#__PURE__*/(0, _styledComponents.css)(["display:inline-block;vertical-align:middle;line-height:1;width:", "px;height:", "px;"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var iconStyle = exports.iconStyle = /*#__PURE__*/(0, _styledComponents.css)(["display:flex;align-items:center;cursor:", ";"], function (props) {
  return props.showPointer ? "pointer" : "inherit";
});
var camelize = exports.camelize = function camelize() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var firstSmall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return name.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return firstSmall && index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s|[-.]+/g, "");
};
var transitionFromAuto = function transitionFromAuto(el, endHeight) {
  el.style.height = window.getComputedStyle(el).height;
  // Force repaint
  //eslint-disable-next-line no-unused-expressions
  el.offsetHeight;
  el.style.height = endHeight + "px";
  // el.style.overflow = 'hidden'
};
var transitionToAuto = exports.transitionToAuto = function transitionToAuto(el) {
  var prevHeight = el.style.height;
  el.style.height = "auto";
  var endHeight = window.getComputedStyle(el).height;
  el.style.height = prevHeight;
  // Force repaint
  //eslint-disable-next-line no-unused-expressions
  el.offsetHeight;
  el.style.height = endHeight;
};
var getCDN = exports.getCDN = function getCDN(link) {
  return "https://b.zmtcdn.com/".concat(link);
};
var onKeySelect = exports.onKeySelect = function onKeySelect(func) {
  return function (e) {
    if (e.key === "Enter" || e.keyCode === 32) {
      func(e);
    }
  };
};
var keyCodes = {
  13: "ENTER",
  37: "LEFT",
  38: "UP",
  39: "RIGHT",
  40: "DOWN"
};
var onKeyChoose = exports.onKeyChoose = function onKeyChoose(func) {
  return function (e) {
    var navKey = keyCodes[e.keyCode] || false;
    if (navKey) func(e, navKey);
  };
};
var wordSplit = exports.wordSplit = function wordSplit(casedWord) {
  return casedWord.split("").reduce(function (word, letter) {
    return word = letter === letter.toUpperCase() ? "".concat(word, " ").concat(letter) : "".concat(word).concat(letter);
  }, "").trim();
};
var filterChildProps = exports.filterChildProps = function filterChildProps(props, excludeKeys) {
  return Object.keys(props).filter(function (key) {
    if (Array.isArray(excludeKeys)) {
      return !excludeKeys.includes(key);
    }
    return excludeKeys !== key;
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};
var mapProps = exports.mapProps = function mapProps(child, extraProps) {
  return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread({}, extraProps));
};
var debounce = exports.debounce = function debounce(fn, delay) {
  var timer = null;
  return window && window.clearTimeout && window.setTimeout ? function () {
    var context = this;
    var thisArgs = Array.prototype.slice.call(arguments);
    if (timer) {
      window.clearTimeout(timer);
    }
    timer = window.setTimeout(function () {
      fn.apply(context, thisArgs);
    }, delay);
  } : fn;
};